<template>
  <section class="section container pt-0">
    <driver-datatable />
  </section>
</template>

<script>
import DriverDatatable from "./driver_datatable/Index.vue";

export default {
  name: "TripDrivers",
  components: {
    DriverDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
